// ADDED: Salary Advance Bracket Page
import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useSalaryAdvanceDeductionBracket } from "../../hooks/useSalaryAdvanceDeductionBracket";
import SalaryAdvanceDeductionBracketModule from "../../components/modules/SalaryAdvanceDeductionBracket/SalaryAdvanceDeductionBracketModule";

const SalaryAdvanceDeductionBracketPage = ({ user, isHideSideMenu }) => {
  const bracketMethods = useSalaryAdvanceDeductionBracket();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Salary Advance Brackets"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Salary Advance Brackets</h3>
            </div>

            <SalaryAdvanceDeductionBracketModule
              user={user}
              {...bracketMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={bracketMethods.showMessage}
        message={bracketMethods.message}
        isSuccess={bracketMethods.isSuccess}
      />

      <LoadingSpinner loading={bracketMethods.loading} />
    </>
  );
};

export default SalaryAdvanceDeductionBracketPage;